type RoleRecordLike = Record<string, unknown>;

/** 读取 updateRole 使用的 id */
export function readRoleRecordId(raw: RoleRecordLike) {
  const value = raw.id ?? raw._id ?? raw.roleId;

  if (value === null || value === undefined || value === '') {
    return '';
  }

  return String(value);
}

/** 读取 updateRolePermissions 使用的 roleId */
export function readRolePermissionRoleId(raw: RoleRecordLike) {
  const value = raw.roleId ?? raw.id ?? raw._id;

  if (value === null || value === undefined || value === '') {
    return '';
  }

  return String(value);
}

function resolveRoleNumericId(roleId: string, record: RoleRecordLike) {
  if (roleId) {
    const parsed = Number(roleId);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }

  const rawId = record.id;
  if (rawId !== null && rawId !== undefined && rawId !== '') {
    const parsed = Number(rawId);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }

  return NaN;
}

export function normalizeRoleRecord(raw: RoleRecordLike | Api.SystemManage.Role): Api.SystemManage.Role {
  const record = raw as RoleRecordLike;
  const roleId = readRolePermissionRoleId(record);
  const menuPermsIds =
    record.menuPermsIds ?? record.menu_perms_ids ?? record.menuIds ?? record.menu_ids ?? record.permissionIds;
  const id = resolveRoleNumericId(roleId, record);

  return {
    ...(record as Api.SystemManage.Role),
    roleId,
    id: Number.isFinite(id) ? id : (record as Api.SystemManage.Role).id,
    name: String(record.name ?? ''),
    roleCode: String(record.roleCode ?? record.role_code ?? ''),
    description: String(record.description ?? ''),
    menuPermsIds: Array.isArray(menuPermsIds) ? menuPermsIds.map(item => Number(item)) : [],
    status:
      record.status !== undefined && record.status !== null
        ? (Number(record.status) as Api.Common.EnableStatus)
        : null,
    createBy: String(record.createBy ?? record.create_by ?? ''),
    createTime: String(record.createTime ?? record.create_time ?? record.createDate ?? record.create_date ?? ''),
    updateBy: String(record.updateBy ?? record.update_by ?? ''),
    updateTime: String(record.updateTime ?? record.update_time ?? record.updateDate ?? record.update_date ?? '')
  };
}

export function normalizeRoleRecords(records: Array<RoleRecordLike | Api.SystemManage.Role>) {
  return records.map(item => normalizeRoleRecord(item));
}

export function getRoleRowKey(row: Api.SystemManage.Role) {
  const id = row.id ?? row.roleId;
  return id === null || id === undefined || String(id) === '' ? '' : String(id);
}
